<template>
  <div class="section">
    Voters
  </div>
</template>

<script>
export default {
  name: 'voters'
}
</script>
